import { render, staticRenderFns } from "./MailsThread.vue?vue&type=template&id=8e5a0a8a&scoped=true"
import script from "./MailsThread.vue?vue&type=script&lang=js"
export * from "./MailsThread.vue?vue&type=script&lang=js"
import style0 from "./MailsThread.vue?vue&type=style&index=0&id=8e5a0a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5a0a8a",
  null
  
)

export default component.exports